import React, { useState } from "react";
import { Button, Card, Form, Input, Typography, message } from "antd";
import { useNavigate } from "react-router-dom";
import { loginAdmin } from "@/services/api";
import { extractTokenFromResponse, setAuthToken } from "@/services/auth";
import { useTheme } from "@/contexts/ThemeContext";

const Login = () => {
  const { isDark } = useTheme();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onFinish = async (values) => {
    setIsSubmitting(true);
    try {
      const response = await loginAdmin(values);
      const responseData = response?.data;
      const token = extractTokenFromResponse(responseData);

      if (responseData?.statuscode !== 1 || !token) {
        message.error("Login failed: token not found in response");
        return;
      }

      setAuthToken(token);
      message.success("Login successful");
      navigate("/", { replace: true });
    } catch (error) {
      const apiMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Invalid email or password";
      message.error(apiMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        background: isDark ? "#09090B" : "#F8FAFC",
      }}
    >
      <Card
        style={{
          width: "100%",
          maxWidth: 420,
          borderRadius: 0,
          border: `1px solid ${isDark ? "#27272A" : "#E4E4E7"}`,
          background: isDark ? "#18181B" : "#FFFFFF",
        }}
      >
        <div style={{ marginBottom: 20 }}>
          <Typography.Title
            level={3}
            style={{
              marginBottom: 6,
              fontFamily: "IBM Plex Sans, sans-serif",
            }}
          >
            Admin Login
          </Typography.Title>
          <Typography.Text style={{ color: isDark ? "#A1A1AA" : "#71717A" }}>
            Sign in to access Media24hr admin dashboard.
          </Typography.Text>
        </div>

        <Form layout="vertical" onFinish={onFinish} autoComplete="off">
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: "Please enter your email" },
              { type: "email", message: "Please enter a valid email" },
            ]}
          >
            <Input
              placeholder="admin@example.com"
              style={{ borderRadius: 0 }}
              data-testid="login-email-input"
            />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Please enter your password" }]}
          >
            <Input.Password
              placeholder="Enter password"
              style={{ borderRadius: 0 }}
              data-testid="login-password-input"
            />
          </Form.Item>

          <Button
            htmlType="submit"
            type="primary"
            block
            loading={isSubmitting}
            style={{ borderRadius: 0, marginTop: 8 }}
            data-testid="login-submit-button"
          >
            Login
          </Button>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
